import { createAction } from '/@/store/utils';

export const setSelectedField = createAction('SELECTED_FIELD:SET_SELECTED_FIELD');
